import React, {Component} from "react";
import _ from "lodash";
import Link from "gatsby-link";

class PostTags extends Component {
  render() {
    const {tags} = this.props;

    // no tags, don't display anything
    if (!tags) {
      return null;
    }

    return (
      <div>
        <span style={{marginRight: "5px"}}>
          Tags:
        </span>
        {tags &&
          tags.map((tag, i) => (
            <Link
              key={tag}
              to={`/tags/${_.kebabCase(tag)}`}
            >
              {tag}
              {i < tags.length - 1 ? ", " : ""}
            </Link>
          ))}
      </div>
    );
  }
}

export default PostTags;



// WEBPACK FOOTER //
// ./src/components/PostTags/PostTags.jsx